import gql from "graphql-tag";

export const PAGE_VIEW_SETTINGS_QUERY = gql`
  query PageViewSettings($page: String!) {
    pageViewSettings(page: $page)
  }
`;

export const SAVE_PAGE_VIEW_SETTINGS_MUTATION = gql`
  mutation SavePageViewSettings($page: String!, $settings: GenericScalar!) {
    savePageViewSettings(page: $page, settings: $settings) {
      success
      message
      page
      data
    }
  }
`;

export const TOGGLE_PAGE_VIEW_SETTINGS_MUTATION = gql`
  mutation TogglePageViewSettings($enable: Boolean!) {
    togglePageViewSettings(enable: $enable) {
      success
      enabled
    }
  }
`;
